import { SET_SELECTED_TAG_SET } from '../../../actions/actionTypes';
import getTagsForLevel from './getTagsForLevel';

/**
 * 選択されたタグセットIDに基づいて、そのタグセットを選択し、そのタグセットの1階層目のタグを取得する。
 * この関数は、選択されたタグセットの1階層目のタグデータを取得するためのAPI呼び出しを行う。
 *
 * @param {string} apiToken - APIトークン
 * @param {string} tagSetId - 選択されたタグセットのID
 */
const selectTagSetAndGetFirstLevelTags = (apiToken, tagSetId) => dispatch => {
  dispatch({
    type: SET_SELECTED_TAG_SET,
    payload: tagSetId,
  });

  dispatch(getTagsForLevel(apiToken, tagSetId, 1));
};

export default selectTagSetAndGetFirstLevelTags;
